import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ModalAtom from "../../../components/atoms/modal/modal";
import { selectProjectDetails } from "../../../store/slices/projectDetailsSlice";
import { useUploadLVFileMutation } from "../../../store/services/lvService";
import { showToast } from "../../../utils/method";
import AddLVForm from "./add-lv-form";

const UploadLVModal = ({
    show,
    onHide,
    projectId,
    lvData,
    onSuccess,
    isLocalProject = false,
}) => {
    const { t } = useTranslation();
    const [uploadLVFile] = useUploadLVFileMutation();

    const projectDetails = useSelector(selectProjectDetails);
    const currentProjectId = projectId || projectDetails?.id;

    const [loading, setLoading] = useState(false);
    const formRef = useRef(null);

    const handleSubmit = async (formData) => {
        try {
            setLoading(true);
            const response = await uploadLVFile({
                projectId: currentProjectId,
                lvId: lvData.id,
                formData,
            }).unwrap();
            if (onSuccess) onSuccess(response);
            showToast(t("lv.upload-success"), { type: "success" });
            onHide();
        } catch (error) {
            showToast(error || t("errors.general"), { type: "error" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalAtom
            title={t("lv.upload-lv-file")}
            body={
                <AddLVForm
                    ref={formRef}
                    projectId={currentProjectId}
                    onSubmit={handleSubmit}
                    loading={loading}
                    mode="upload"
                    initialData={lvData}
                    onCancel={onHide}
                    isLocalProject={isLocalProject}
                    hideButtons
                />
            }
            show={show}
            handleClose={onHide}
            handleSubmit={() => formRef.current?.triggerSubmit()}
            saveText="lv.upload-file"
            disabled={loading}
            size="lg"
            backdrop="static"
        />
    );
};

export default UploadLVModal;
